import React from 'react';
import { Box, Card, CardContent, Button, Typography, Container } from '@mui/material';
import { School as SchoolIcon, Person as ParentIcon, AdminPanelSettings as AdminIcon, Business as AgencyIcon } from '@mui/icons-material';

const LoginSelector = () => {
  const handleLoginTypeSelect = (type) => {
    switch (type) {
      case 'school':
        window.location.href = '/school';
        break;
      case 'parent':
        window.location.href = '/parent';
        break;
      case 'agency':
        window.location.href = '/agency';
        break;
      case 'admin':
        window.location.href = '/admin';
        break;
      default:
        window.location.href = '/';
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 800, p: 4 }}>
          <CardContent>
            <Box textAlign="center" mb={4}>
              <Typography variant="h3" fontWeight="bold" gutterBottom>
                GPS Tracking System
              </Typography>
              <Typography variant="h6" color="textSecondary">
                Select your login type to continue
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: 3,
                mt: 4
              }}
            >
              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('school')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <SchoolIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    School Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Access school dashboard to manage students, devices, and payments
                  </Typography>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('school')}
                  >
                    Login as School
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('parent')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <ParentIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Parent Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Track your child's location and view their activity
                  </Typography>
                  <Button
                    variant="contained"
                    color="success"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('parent')}
                  >
                    Login as Parent
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('agency')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <AgencyIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Agency Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Manage multiple schools and coordinate operations
                  </Typography>
                  <Button
                    variant="contained"
                    color="warning"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('agency')}
                  >
                    Login as Agency
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('admin')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <AdminIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Admin Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Manage schools, devices, and system administration
                  </Typography>
                  <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('admin')}
                  >
                    Login as Admin
                  </Button>
                </CardContent>
              </Card>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginSelector;